/**
 * 相亲订单请求接口
 * @author 王振宇
 * @since 2022-06-28
 */
export default (function (_ref) {
  var service = _ref.service,
    request = _ref.request,
    serviceForMock = _ref.serviceForMock,
    requestForMock = _ref.requestForMock,
    mock = _ref.mock,
    faker = _ref.faker,
    tools = _ref.tools;
  return {
    GET_BLINDDATAORDER_USEINFO_PAGE_LIST: function GET_BLINDDATAORDER_USEINFO_PAGE_LIST() {
      var data = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};
      data.operatorUserId = tools.getUserId();
      data.loginType = tools.getLoginType();
      return request({
        url: '/admin/v1/blindDataOrderUseInfo/getPageList',
        method: 'post',
        data: data
      });
    },
    GET_BLINDDATAORDER_PAGE_LIST: function GET_BLINDDATAORDER_PAGE_LIST() {
      var data = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};
      data.operatorUserId = tools.getUserId();
      data.loginType = tools.getLoginType();
      return request({
        url: '/admin/v1/blindDataOrder/getPageList',
        method: 'post',
        data: data
      });
    },
    GET_BLINDDATAORDER_LIST: function GET_BLINDDATAORDER_LIST() {
      var data = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};
      data.operatorUserId = tools.getUserId();
      data.loginType = tools.getLoginType();
      return request({
        url: '/admin/v1/blindDataOrder/getList',
        method: 'get',
        params: data
      });
    },
    GET_BLINDDATAORDER_INFO: function GET_BLINDDATAORDER_INFO() {
      var data = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};
      data.operatorUserId = tools.getUserId();
      data.loginType = tools.getLoginType();
      return request({
        url: '/admin/v1/blindDataOrder/info',
        method: 'get',
        params: data
      });
    },
    SAVE_BLINDDATAORDER: function SAVE_BLINDDATAORDER() {
      var data = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};
      data.operatorUserId = tools.getUserId();
      data.loginType = tools.getLoginType();
      return request({
        url: '/admin/v1/blindDataOrder/save',
        method: 'post',
        data: data
      });
    },
    GIVE_SAVE_BLINDDATAORDER: function GIVE_SAVE_BLINDDATAORDER() {
      var data = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};
      data.operatorUserId = tools.getUserId();
      data.loginType = tools.getLoginType();
      return request({
        url: '/admin/v1/blindDataOrder/giveSave',
        method: 'post',
        data: data
      });
    },
    UPDATE_BLINDDATAORDER: function UPDATE_BLINDDATAORDER() {
      var data = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};
      data.operatorUserId = tools.getUserId();
      data.loginType = tools.getLoginType();
      return request({
        url: '/admin/v1/blindDataOrder/update',
        method: 'put',
        data: data
      });
    },
    DELETE_BLINDDATAORDER: function DELETE_BLINDDATAORDER() {
      var data = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};
      data.operatorUserId = tools.getUserId();
      data.loginType = tools.getLoginType();
      return request({
        url: '/admin/v1/blindDataOrder/delete',
        method: 'delete',
        data: data
      });
    },
    DELETE_BATCH_BLINDDATAORDER: function DELETE_BATCH_BLINDDATAORDER() {
      var data = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};
      data.operatorUserId = tools.getUserId();
      data.loginType = tools.getLoginType();
      return request({
        url: '/admin/v1/blindDataOrder/deleteBatch',
        method: 'delete',
        data: data
      });
    },
    ADD_BLINDDATAORDER_USE_INFO: function ADD_BLINDDATAORDER_USE_INFO() {
      var data = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};
      data.operatorUserId = tools.getUserId();
      data.loginType = tools.getLoginType();
      return request({
        url: '/admin/v1/blindDataOrderUseInfo/save',
        method: 'post',
        data: data
      });
    }
  };
});